import React, { useCallback, useState } from 'react';
import { Dropdown, DropdownMenu } from '@folio/stripes/components';
import { t } from '../../services';
import { ActionButtonsList } from './components';
import css from './ActionMenu.module.css';
export var ActionMenu = function (_a) {
    var actionButtons = _a.actionButtons, children = _a.children;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var handleToggle = useCallback(function () { return setOpen(!open); }, [open]);
    var handleClick = useCallback(function (onClick) {
        handleToggle();
        onClick();
    }, [handleToggle]);
    return (React.createElement(Dropdown, { id: "AddPermissionDropdown", "data-testid": "paneDropdownButton", label: t('paneHeader.button.actions'), buttonProps: { buttonStyle: 'primary', bottomMargin0: true }, open: open, onToggle: handleToggle },
        React.createElement(DropdownMenu, { "aria-label": "available permissions" },
            React.createElement("div", { className: children ? css.actionMenuGroup : '' },
                React.createElement(ActionButtonsList, { buttons: actionButtons, handleClick: handleClick })),
            children)));
};
